import {
	createStore
} from "vuex";

import {
	getMailLetterGoods,
	getAddress,
	getMy,
	getOrderCategory,
	getRecharge,
	getTemplateCategory,
	getTemplateList,
	getConfig,
	getLetterConfig,
	getLetterSpecs,
	getOrderStatusNum,
	getChatMessageConfig,
	getUserInfo,
	getHome,
	postAppPush,
	getCouponList,
	getFollowQrcode,
	getInviteConfig,
	getAiConfig
} from '@/common/api.js'
// #ifdef H5
import {
	getAdminChatMessageConfig
} from '@/common/api.js'
// #endif
import {
	LOGIN_TOKEN_KEY,
	WEB_SOCKET_TOKEN_KEY
} from '@/config/cache'
import {
	HTTP_REQUEST_URL,
	APP_VERSION_NAME
} from '@/config/app'
import Cache from '@/utils/cache'
import secure from './modules/secure.js'

console.log('HTTP_REQUEST_URL', HTTP_REQUEST_URL)
const store = createStore({
	modules: {
		secure
	},
	state: {
		version: APP_VERSION_NAME,
		uploadUrl: `${HTTP_REQUEST_URL}/api/v1/upload/image`,
		uploadFileUrl: `${HTTP_REQUEST_URL}/api/v1/upload/file`,
		// #ifdef H5
		resUrl: HTTP_REQUEST_URL,
		// #endif
		// #ifndef H5
		resUrl: HTTP_REQUEST_URL,
		// #endif

		//是否登录
		isLogin: Cache.get(LOGIN_TOKEN_KEY) || false,
		isHome: false,
		cache: {}, // 缓存对象
		appConfig: {
			source: 'local',
			upload: {
				mode: 'local',
				list: {}
			},
			app: {
				logo: '',
				name: '',
				quotaName: '金币',
				quotaImage: '',
				version: 1,
				isShowVip: 1,
				isShowPayTip: true
			},
			kf: {
				wxKfZh: '',
				wxKfQrcode: '',
				wxFollowQrcode: '',
				wxKfPhone: ''
			},
			isBalance: true,
			receiveBalance: false,
			isReviewer: true,
			isAppReviewer: true,
			user: {
				defaultImage: ''
			},
			share: {
				uid: 0,
				title: '',
				images: []
			},
			ad: [],
			superAdmin: false
		},
		userToken: '',
		userInfo: {
			userId: 0,
			avatar: '',
			nickname: '',
			money: 0,
			points: 0,
			isBindPhone: 0,
			showWrite: false,
			showRecharge: false,
			showTask: false,
			letterStat: {
				day: 0,
				count: 0
			},
			couponStat: 0
		},
		familys: [],
		editImages: [], //生成的信纸
		diyPaper: {
			url: '',
			lines: [],
			config: {},
			printDirection: 0
		},
		diyImg: '',


		orderStatusNum: {
			order: {}
		}, //订单ID

		countdownList: [], //倒计时事件列表（从config接口获取）
		
		// 主题相关
		theme: 'light', // 当前主题：light 或 dark
		themeConfig: null, // 主题配置对象
	},
	mutations: {
		setAppConfig(state, data) {
			console.log('设置App配置', data)
			state.appConfig = data
		},
		SET_CACHE(state, {
			key,
			value
		}) {
			state.cache[key] = value // 设置缓存值
		},
		// 设置倒计时事件列表
		setCountdownList(state, list) {
			state.countdownList = list || []
		},
		// 设置用户信息
		setUserInfo(state, data) {
			console.log('setUserInfo', data)
			state.userInfo = data
		},
		//订单状态NUM
		setOrderStatusNum(state, order) {
			let index = order.index ? order.index : 2,
				num = order.tabBar > 99 ? '99+' : order.tabBar
			if (num) {
				uni.setTabBarBadge({
					index,
					text: `${num}`,
					complete(res) {
						console.log('设置tab角标结果', res)
					}
				})
			} else {
				uni.removeTabBarBadge({
					index,
					complete(res) {
						console.log('移除tab角标结果', res)
					}
				})
			}
			state.orderStatusNum = order
		},
		//聊天未读数
		setChatUnreadNum(state, unreadNum) {
			let index = 1,
				num = unreadNum > 99 ? '99+' : unreadNum
			if (num) {
				uni.setTabBarBadge({
					index,
					text: `${num}`,
					complete(res) {
						console.log('设置tab角标结果', res)
					}
				})
			} else {
				uni.removeTabBarBadge({
					index,
					complete(res) {
						console.log('移除tab角标结果', res)
					}
				})
			}
		},
		setFamilys(state, family) {
			let familys = state.familys
			familys.push(family)
			state.familys = familys
		},
		setEditImages(state, images) {
			state.editImages = images
		},
		setDiyPaper(state, data) {
			state.diyPaper = data
		},
		setDiyImg(state, data) {
			state.diyImg = data
		},
		//登录
		setUserToken(state, data) {
			if (data) {
				let userToken, exp = 0
				if (typeof data === 'object') {
					console.log('对象的TOKEN', data)
					userToken = data.token
					exp = data.expire
					Cache.set(WEB_SOCKET_TOKEN_KEY, data.web_socket_token || userToken, exp)
				} else {
					console.log('字符串的TOKEN', data)
					userToken = data
				}
				state.userToken = userToken
				Cache.set(LOGIN_TOKEN_KEY, userToken, exp)
				//更新
				this.dispatch('getMy', {
					data: {},
					cache: true
				})
				this.dispatch('getAppConfig', {
					cache: true
				})
				// #ifdef APP-PLUS
				this.dispatch('postAppPush')
				// #endif
			}
			state.isLogin = true
		},
		//退出登录
		logout(state) {
			state.token = ""
			state.isLogin = false
			Cache.clear(LOGIN_TOKEN_KEY)
			Cache.clear(WEB_SOCKET_TOKEN_KEY)
			this.dispatch('getMy', {
				data: {},
				cache: true
			})
			this.dispatch('getAppConfig', {
				cache: true
			})
			this.dispatch('getOrderStatusNum', true)
			// #ifdef APP-PLUS
			this.dispatch('postAppPush')
			// #endif
		},
		setIsHome(state, value) {
			console.log('setIsHome', value)
			state.isHome = value
		},
		// 设置主题
		setTheme(state, theme) {
			console.log('设置主题', theme)
			state.theme = theme || 'light'
		},
		// 设置主题配置
		setThemeConfig(state, config) {
			console.log('设置主题配置', config)
			state.themeConfig = config
		},
	},
	getters: {
		getAppConfig(state) {
			return state.appConfig
		},
		isFamilys: (state) => (value) => {
			console.log('state.familys', state.familys)
			return state.familys.indexOf(value) !== -1
		},
		// 获取当前主题
		getTheme(state) {
			return state.theme
		},
		// 获取主题配置
		getThemeConfig(state) {
			return state.themeConfig
		},
	},
	actions: {
		//App推送同步
		postAppPush({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				const key = 'postAppPush'
				// #ifdef APP-PLUS
				//消息推送获取cid
				uni.getPushClientId({
					success: (res) => {
						postAppPush({
							data: {
								cid: res.cid
							}
						}).then((res) => {
							const {
								data: {
									data,
									code,
									msg
								}
							} = res
							console.log(`请求成功：${key}`, res)
							resolve(res)
						}).catch(e => {
							console.error(`请求失败：${key}`, e)
							reject(e)
						})
					},
					fail(err) {
						console.error(`getPushClientId请求失败：${key}`, err)
					}
				})
				// #endif
			})
		},
		//刷新倒计时列表（从config接口获取）
		refreshCountdownList({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				const key = 'refreshCountdownList'
				getConfig().then((res) => {
					const {
						data: {
							data,
							code,
							msg
						}
					} = res
					console.log(`请求成功：${key}`, res)
					if (code === 1) {
						commit('setAppConfig', data)
						if (data.countdownList && Array.isArray(data.countdownList)) {
							commit("setCountdownList", data.countdownList)
						}
					}
					resolve(res)
				}).catch(e => {
					console.error(`请求失败：${key}`, e)
					reject(e)
				})
			})
		},
		// 更新倒计时（别名，兼容旧代码）
		updateCountdownDay({
			dispatch
		}) {
			return dispatch('refreshCountdownList')
		},
		//获取用户信息
		getUserInfo({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				const url = 'getUserInfo'
				const method = 'GET'
				const key = `${url}-${method}`
				getUserInfo().then((res) => {
					const {
						data: {
							data,
							code,
							msg
						}
					} = res
					console.log(`请求成功：${key}`, res)
					if (code === 1) {
						commit('setUserInfo', data)
					}
					resolve(res)
				}).catch(e => {
					console.error(`请求失败：${key}`, e)
					reject(e)
				})
			})
		},
		//获取订单状态数量
		getOrderStatusNum({
			commit,
			state
		}, updateCache = false) {
			return new Promise(async (resolve, reject) => {
				const url = 'getOrderStatusNum'
				const method = 'GET'
				const key = `${url}-${method}`
				if (state.cache[key] && !updateCache) {
					commit('setOrderStatusNum', state.cache[key])
					resolve(state.cache[key])
				} else {
					getOrderStatusNum().then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: data
							})
							commit('setOrderStatusNum', data)
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		getFollowQrcode({
			commit,
			state
		}, {
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getFollowQrcode'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getFollowQrcode({
						data
					}).then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		getCouponList({
			commit,
			state
		}, {
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getCouponList'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getCouponList({
						data
					}).then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		getLetterSpecs({
			commit,
			state
		}, {
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getLetterSpecs'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getLetterSpecs({
						data
					}).then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		getLetterConfig({
			commit,
			state
		}, {
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getLetterConfig'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getLetterConfig({
						data
					}).then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		getAppConfig({
			commit,
			state
		}, {
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getAppConfig'
				const method = 'GET'
				const data = {}
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.appConfig && state.appConfig.source !== 'local' && !cache) {
					resolve(state.appConfig)
				} else {
					getConfig({
						data
					}).then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('setAppConfig', data)
							// 同步设置倒计时列表
							if (data.countdownList && Array.isArray(data.countdownList)) {
								commit("setCountdownList", data.countdownList)
							}
							resolve(res)
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		getTemplateCategory({
			commit,
			state
		}, {
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getTemplateCategory'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getTemplateCategory({
						data
					}).then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		getTemplateList({
			commit,
			state
		}, {
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getTemplateList'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getTemplateList({
						data
					}).then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		//获取充值
		getRecharge({
			commit,
			state
		}, {
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getRecharge'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getRecharge().then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		//获取订单分类
		getOrderCategory({
			commit,
			state
		}, {
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getOrderCategory'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getOrderCategory().then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		//获取个人中心
		getMy({
			commit,
			state
		}, {
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getMy'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getMy({
						data
					}).then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		//获取地址
		getAddress({
			commit,
			state
		}, {
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getAddress'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getAddress().then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		//获取聊天配置
		getChatMessageConfig({
			commit,
			state
		}, {
			method = 'GET',
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getChatMessageConfig'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getChatMessageConfig().then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},

		// #ifdef H5
		//获取聊天配置
		getAdminChatMessageConfig({
			commit,
			state
		}, {
			method = 'GET',
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getAdminChatMessageConfig'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getAdminChatMessageConfig().then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		// #endif


		//获取未读消息数  此接口：寄信助手屏蔽
		reqChatUnreadNum({
			commit,
			state
		}, {
			data = {},
			cache = false,
			setChatUnreadNum = true
		}) {
			return new Promise(async (resolve, reject) => {
				const url = '/api/v1/chat_message/chatUnreadNum'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				console.log(`执行reqChatUnreadNum`)

				//这里必须设置>=0  因为未读消息可能是0  直接判断 会走不进缓存
				if (state.cache[key] >= 0 && !cache) {
					if (setChatUnreadNum) commit('setChatUnreadNum', state.cache[key])
					resolve(state.cache[key])
				} else {
					await uni.$http.request({
						url,
						data,
						method
					}).then(res => {
						console.log(`请求成功：${key}`, res.data)
						if (res.data.code === 1) {
							commit('SET_CACHE', {
								key,
								value: res.data.data.unreadNum
							})
							if (setChatUnreadNum) commit('setChatUnreadNum', res
								.data.data.unreadNum)
						}
						resolve(res.data)
					}).catch(e => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		//获取寄信商品列表
		getMailLetterGoods({
			commit,
			state
		}, {
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = 'getMailLetterGoods'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getMailLetterGoods().then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},


		//页面协议 注意修改的接口
		reqPageProtocol({
			commit,
			state
		}, {
			method = 'GET',
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = '/api/mailing/v5/app/pageProtocol'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					await uni.$http.request({
						url,
						data,
						method
					}).then(res => {
						console.log(`请求成功：${key}`, res.data)
						commit('SET_CACHE', {
							key,
							value: res.data
						})
						resolve(res.data)
					}).catch(e => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		//帮助中心 注意修改的接口
		reqHelp({
			commit,
			state
		}, {
			method = 'GET',
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = '/api/mailing/v5/my/help'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					await uni.$http.request({
						url,
						data,
						method
					}).then(res => {
						console.log(`请求成功：${key}`, res.data)
						commit('SET_CACHE', {
							key,
							value: res.data
						})
						resolve(res.data)
					}).catch(e => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		//获取地址
		reqAddressCity({
			commit,
			state
		}, {
			method = 'GET',
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				const url = '/api/mailing/v5/order/addressCity'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					await uni.$http.request({
						url,
						data,
						method,
						dataType: 'json'
					}).then(res => {
						console.log(`请求成功：${key}`, res.data)
						commit('SET_CACHE', {
							key,
							value: res.data
						})
						resolve(res.data)
					}).catch(e => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		//获取邀请界面配置信息
		reqInviteConfig({
			commit,
			state
		}, {
			method = 'GET',
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				console.log('reqInviteConfig')
				const url = 'getInviteConfig'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getInviteConfig({
						data
					}).then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},
		//获取AI配置
		reqAiConfig({
			commit,
			state
		}, {
			method = 'GET',
			data = {},
			cache = false
		}) {
			return new Promise(async (resolve, reject) => {
				console.log('getAiConfig')
				const url = 'getAiConfig'
				const method = 'GET'
				const key = `${url}-${method}-${JSON.stringify(data)}`
				if (state.cache[key] && !cache) {
					resolve(state.cache[key])
				} else {
					getAiConfig({
						data
					}).then((res) => {
						const {
							data: {
								data,
								code,
								msg
							}
						} = res
						console.log(`请求成功：${key}`, res.data)
						if (code === 1) {
							commit('SET_CACHE', {
								key,
								value: res
							})
						}
						resolve(res)
					}).catch((e) => {
						console.error(`请求失败：${key}`, e)
						reject(e)
					})
				}
			})
		},


	}
})

export default store